function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _set_prototype_of(subClass, superClass);
}
function _set_prototype_of(o, p) {
    _set_prototype_of = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _set_prototype_of(o, p);
}
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { Component } from "react";
import logger, { LapelError } from "../../logger";
import { whenDebugging } from "../../utils/debug";
import analytics, { EventNames } from "../../analytics";
var ErrorBoundary = /*#__PURE__*/ function(Component) {
    "use strict";
    _inherits(ErrorBoundary, Component);
    function ErrorBoundary(props) {
        var _this;
        _this = Component.call(this, props) || this;
        _this.state = {
            hasError: false,
            error: null,
            debugLevel: null,
            debugUnsub: null
        };
        var fallback = props.fallback;
        if (fallback === undefined) {
            logger.warn(new LapelError("ErrorBoundary fallback not set!"));
        }
        return _this;
    }
    var _proto = ErrorBoundary.prototype;
    _proto.componentDidMount = function componentDidMount() {
        var _this = this;
        var debugUnsub = whenDebugging(function(debugLevel) {
            _this.setState({
                debugLevel: debugLevel
            });
        });
        this.setState({
            debugUnsub: debugUnsub
        });
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        var debugUnsub = this.state.debugUnsub;
        if (debugUnsub) {
            debugUnsub();
        }
    };
    _proto.componentDidCatch = function componentDidCatch(error) {
        var _this_props = this.props, name = _this_props.name, onError = _this_props.onError;
        logger.error(new LapelError(error.message + ' while rendering "' + name + '"', {
            cause: error
        }), {
            tags: {
                functionName: "ErrorBoundary"
            },
            fingerprint: [
                "ErrorBoundary",
                name
            ]
        }, function(scope) {
            scope.setTag("ab-test", name);
        });
        if (typeof onError === "function") {
            onError(error);
        }
        analytics.track(EventNames.RENDER_ERROR, {
            name: name,
            error: error
        });
    };
    _proto.render = function render() {
        var _this_state = this.state, hasError = _this_state.hasError, error = _this_state.error, debugLevel = _this_state.debugLevel;
        var _this_props = this.props, _this_props_children = _this_props.children, children = _this_props_children === void 0 ? null : _this_props_children, _this_props_fallback = _this_props.fallback, fallback = _this_props_fallback === void 0 ? null : _this_props_fallback;
        if (hasError) {
            return /*#__PURE__*/ _jsxs(_Fragment, {
                children: [
                    fallback,
                    debugLevel && /*#__PURE__*/ _jsxs("div", {
                        className: "error-boundary-debug",
                        children: [
                            /*#__PURE__*/ _jsx("h3", {
                                children: "AB Testing Rendering Error"
                            }),
                            /*#__PURE__*/ _jsx("p", {
                                children: error.toString()
                            }),
                            /*#__PURE__*/ _jsx("pre", {
                                style: {
                                    whiteSpace: "pre-wrap",
                                    wordBreak: "break-word",
                                    lineHeight: "20px",
                                    fontSize: "14px",
                                    margin: "1rem",
                                    maxHeight: "60px",
                                    overflow: "auto"
                                },
                                children: error.stack
                            })
                        ]
                    })
                ]
            });
        }
        return children;
    };
    ErrorBoundary.getDerivedStateFromError = function getDerivedStateFromError(error) {
        return {
            hasError: true,
            error: error
        };
    };
    return ErrorBoundary;
}(Component);
export { ErrorBoundary };

//# sourceMappingURL=ErrorBoundary.js.map